module.exports = __webpack_public_path__ + "public/images/schedule/schedule-jazz.eabc61bb9f2c2eda6e6b168b2dfd4e7d.svg";